var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HtmlNumberNew } from '../html-elements/module';
import { GraphControllerV2 } from './graph-v2';
var TotalPlus = /** @class */ (function (_super) {
    __extends(TotalPlus, _super);
    function TotalPlus(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        return _this;
    }
    TotalPlus.prototype.pre = function () {
        this._addMargin(200, 0, 10, 0);
        this._addPadding(0, 20, 0, 0);
    };
    TotalPlus.prototype.init = function () {
        this._init();
        this.config.paddingInner = 0;
        this.config.paddingOuter = 0;
        //    this.config.extra.currency = true;
        this.htmlNumber = new HtmlNumberNew(this);
        this.htmlNumber.draw();
        this.update(this.data, this.segment, false);
    };
    TotalPlus.prototype.prepareData = function (data) {
        return {
            "history": null,
            "latest": data[0],
            "slice": null,
        };
    };
    TotalPlus.prototype.redraw = function (data) {
        this.htmlNumber.redraw(data);
    };
    TotalPlus.prototype.draw = function (data) { };
    TotalPlus.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return TotalPlus;
}(GraphControllerV2));
export { TotalPlus };
